

export const calculateAgeWithDateString = (fechaNacimientoStr, fechaReferencia=null) => {

  const fechaNacimiento = new Date(fechaNacimientoStr);
  
  const fechaActual = fechaReferencia 
    ? new Date(fechaReferencia) 
    : new Date();

  let edad = fechaActual.getFullYear() - fechaNacimiento.getFullYear();

  const mesActual     = fechaActual.getMonth();
  const diaActual     = fechaActual.getDate();
  const mesNacimiento = fechaNacimiento.getMonth();
  const diaNacimiento = fechaNacimiento.getDate();

  if (mesActual < mesNacimiento || (mesActual === mesNacimiento && diaActual < diaNacimiento)) {
    edad--;
  }

  return edad;
}



export const calculteAgeYearsMonthsDays = (fechaNacimientoStr) => {
  
  const [year, month, day] = fechaNacimientoStr.split("-").map(Number);
  const fechaNacimiento = new Date(year, month - 1, day); // mes base 0
  const hoy = new Date();
  const fechaActual = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate()); // quitamos horas

  let years  = fechaActual.getFullYear() - fechaNacimiento.getFullYear();
  let months = fechaActual.getMonth() - fechaNacimiento.getMonth();
  let days   = fechaActual.getDate() - fechaNacimiento.getDate();

  if (days < 0) {
    months--;
    const prevMonth = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 0);
    days += prevMonth.getDate();
  }

  if (months < 0) {
    years--;
    months += 12;
  }

  return { years, months, days };
};



export const getCurrentDate = () => {
  const date  = new Date();
  const year  = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day   = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}



export const formatDateToDB = (dateTimeString) => {
  if (!dateTimeString) return '';
  
  const date    = new Date(dateTimeString);
  const year    = date.getFullYear();
  const month   = String(date.getMonth() + 1).padStart(2, '0');
  const day     = String(date.getDate()).padStart(2, '0');
  const hours   = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}`;
}




export const stringDateToGeneralDate = (dateTimeString) => {
  if (!dateTimeString) return '';
  
  const date    = new Date(dateTimeString);
  const year    = date.getFullYear();
  const month   = String(date.getMonth() + 1).padStart(2, '0');
  const day     = String(date.getDate()).padStart(2, '0');
  const hours   = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return {
    date: `${year}-${month}-${day}`,
    time: `${hours}:${minutes}`
  }
}


export const convertDateToYYYYMMDD = (date) => {
  if (!date) return null;
  const [dia, mes, anio] = date.split('/');
  const fechaFormateada = `${anio}-${mes}-${dia}`;
  return fechaFormateada;
}